import { Component, OnInit, Inject, Input } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogDataComment } from 'src/app/interfaces/dialog-data-comment';

@Component({
  selector: 'app-handover-detail-comments',
  templateUrl: './handover-detail-comments.component.html',
  styleUrls: ['./handover-detail-comments.component.scss'],
  standalone: false,
})
export class HandoverDetailCommentsComponent implements OnInit {
  constructor(
    private dialogRef: MatDialogRef<HandoverDetailCommentsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogDataComment
  ) {}

  ngOnInit(): void {
    const rect = this.data.target.nativeElement.getBoundingClientRect();
    this.dialogRef.updatePosition({
      left: `${rect.left + this.data.leftOffset}px`,
      top: `${rect.bottom + this.data.topOffset}px`,
    });
    if (!this.data.maxLength) {
      this.data.maxLength = 200;
    }
  }
}
